import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import ExampleItemView from "./ExampleItemView";
import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";

export default class BottomHudView extends AbstractView {

    constructor(target, languagePack) {
        super(target);
        this._languagePack = languagePack;
        this._target.findLabelTextfield.text = this.getText("hud.findLabel");

        this._sampleView = new ExampleItemView(this._target.bird);
        this._sampleViewOrigY = this._target.bird.y;

        this._handleDoneClick = this._handleDoneClick.bind(this);
        this._buttonSubmit = this.createButton(this._target.button, this._handleDoneClick, this.getText("hud.buttonSubmit"));
        this._buttonSubmit.setEnabled(false);

        CacheUtil.cache(this._target.findLabelTextfield, undefined, undefined, undefined, undefined, 3);
    }

    enableSubmit(bool) {
        this._buttonSubmit.setEnabled(bool);
    }

    setPuzzleIndex(idx, total) {
        this._target.locationTextfield.text = (idx + 1) + "/" + total;

        const label = idx < total - 1 ? this.getText("hud.buttonSubmit") : this.getText("hud.buttonSubmitLast");
        this._buttonSubmit.setLabel(label);
    }

    setSample(skin) {
        this._sampleView.content = skin;
    }

    crossFadeSample(skin, duration, delayBetween = 0) {
        const target = this._sampleView.target;
        const origY = this._sampleViewOrigY;
        createjs.Tween.get(target)
            .to({ alpha: 0, y: origY + 100 }, duration / 2, createjs.Ease.quadIn)
            .call(_ => {
                target.y = origY - 100;
                this.setSample(skin);
            })
            .wait(delayBetween)
            .to({ alpha: 1, y: origY }, duration / 2, createjs.Ease.quadOut);
    }

    _handleDoneClick() {
        this.dispatchEvent(BottomHudView.SUBMIT)
    }
}

BottomHudView.SUBMIT = "BottomHudView.SUBMIT";

function padTime(str) {
    return ("0" + str).substr(-2);
}